import { Amplify } from 'aws-amplify';
import amplifyConfig from './amplifyConfig';

const configureAmplify = () => Amplify.configure(amplifyConfig);

export default configureAmplify;
